export default __webpack_public_path__ + "2df9549443663153227e65508bc04ddb.png";